// extracted by mini-css-extract-plugin
export var baseButton = "_os-0";
export var controlsArrowKeys = "_os-1";
export var controlsResetButton = "_os-2";
export var lightGameButton = "_os-4 _os-0";
export var playAgainButton = "_os-5 _os-0";
export var startGameButton = "_os-3 _os-0";